<template>
  <div>
    <el-form
      :model="form"
      label-position="right"
      label-width="110px"
      :rules="formRules"
      ref="form"
    >
     <el-form-item label="主办方" prop="matchId">
          <el-select v-model="form.matchId">
            <el-option
              v-for="item in matchOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" maxlength="255"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <div class="editor-container">
          <editor
            :config="config"
            ref="ue"
            :id="'uedoc'"
            :value.sync="form.content"
          ></editor>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="gotoArticle">取 消</el-button>
      <el-button type="primary" @click="submitForm" :loading="isLoading"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import API from '../apis/article'
import MATCHAPI from '../apis/match'

import Editor from '../components/UEditor'
export default {
  components: {
    Editor
  },
  data () {
    return {
      isLoading: false,
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 450
      },
      categories: [
        { name: '最新消息', value: 1 },
        { name: '关于我们', value: 2 },
      ],
      form: {
        id: 0,
        title: '',
        categoryId: 1,
        content: '',
        matchId:null,
      },
      matchOptions:[],
      formRules: {
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        caption: [{ required: true, message: '请输入领队', trigger: 'blur' }],
        coach: [{ required: true, message: '请输入教练', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      }
    }

  },
  methods: {
    gotoArticle () {
      this.$router.push('/articles')
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          params.content = this.$refs.ue.getUEContent();
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                this.gotoArticle()
              } else {
                this.$message.error({ showClose: true, message: data.message, duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.gotoArticle()
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: result.message, duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    }
  }, mounted () {
    var id = this.$route.query.id;
    if (id > 0) {
      API.get({ id: id }).then(result => {
        this.form = Object.assign({}, result.result)
        this.form.matchId=this.form.matchId.toString()
        this.$refs.ue.setContent(this.form.content)
      })
    }
    MATCHAPI.select().then(result=>{
      this.matchOptions=result.result;
    }
    );
  }
}
</script>


// WEBPACK FOOTER //
// src/views/PublishArticle.vue